/**
 * Utility functions for grouping apellyasiyas by exam/collection
 */

import { YoklaAssignment } from '../types';

export interface ExamApellyasiyaGroup {
  collectionName: string;
  examName: string;
  examType: 'buraxilis' | 'Blok';
  appeals: YoklaAssignment[];
  totalCount: number;
  completedCount: number;
  progress: number;
}

/**
 * Group apellyasiya assignments by collectionName (exam)
 */
export const groupApellyasiyasByExam = (
  apellyasiyaAssignments: YoklaAssignment[],
  examData: { [collectionName: string]: { name: string; type: string } }
): ExamApellyasiyaGroup[] => {
  const groupsMap = new Map<string, ExamApellyasiyaGroup>();

  apellyasiyaAssignments.forEach((appeal) => {
    const collectionName = appeal.collectionName || 'scanned2610';
    const examInfo = examData[collectionName] || { name: 'Naməlum İmtahan', type: 'buraxilis' };
    
    if (!groupsMap.has(collectionName)) {
      groupsMap.set(collectionName, {
        collectionName,
        examName: examInfo.name,
        examType: examInfo.type === 'buraxilis' ? 'buraxilis' : 'Blok',
        appeals: [],
        totalCount: 0,
        completedCount: 0,
        progress: 0,
      });
    }

    const group = groupsMap.get(collectionName)!;
    group.appeals.push(appeal);
    group.totalCount++;
    
    // Count completed appeals (status === 'completed')
    if (appeal.status === 'completed') {
      group.completedCount++;
    }
  });

  // Calculate progress for each group
  const groups = Array.from(groupsMap.values());
  groups.forEach((group) => {
    group.progress = group.totalCount > 0 
      ? (group.completedCount / group.totalCount) * 100 
      : 0;
    
    // Sort appeals by newest first
    group.appeals.sort((a, b) => {
      const timeA = a.createdAt?.toMillis ? a.createdAt.toMillis() : (a.createdAt as any)?.seconds ? (a.createdAt as any).seconds * 1000 : 0;
      const timeB = b.createdAt?.toMillis ? b.createdAt.toMillis() : (b.createdAt as any)?.seconds ? (b.createdAt as any).seconds * 1000 : 0;
      return timeB - timeA;
    });
  });

  // Sort groups by exam name
  groups.sort((a, b) => a.examName.localeCompare(b.examName));

  return groups;
};
